import { IntlFormatters } from 'react-intl';

import { TX_STATUS, TxType } from '@context/constants';

export const getFarmDepositFlow = (
  formatMessage: IntlFormatters['formatMessage'],
  tickerA: string,
  tickerB: string,
  txStatus: TxType,
  error: boolean,
  errorMessage: string,
): StepProps[] => {
  const steps = [
    {
      title: formatMessage(
        { id: 'farms.deposit.approveToken' },
        { PAIR: `${tickerA}/${tickerB}` },
      ),
      loading: txStatus === TX_STATUS.ApproveCoin0 && !error,
      approved: txStatus !== TX_STATUS.ApproveCoin0,
      error:
        txStatus === TX_STATUS.ApproveCoin0 && error ? 'Rejected' : undefined,
      errorMessage:
        errorMessage ||
        formatMessage(
          {
            id: 'farms.deposit.approveTokenError',
          },
          { PAIR: `${tickerA}/${tickerB}` },
        ),
    },
    {
      title: formatMessage({
        id: 'farms.deposit.confirm',
      }),
      loading: txStatus === TX_STATUS.Confirm && !error,
      approved: ![
        TX_STATUS.ApproveCoin0,
        TX_STATUS.ApproveCoin1,
        TX_STATUS.Confirm,
      ].includes(txStatus),
      error: txStatus === TX_STATUS.Confirm && error ? 'Rejected' : undefined,
      errorMessage:
        errorMessage ||
        formatMessage({
          id: 'farms.deposit.confirmError',
        }),
    },
    {
      title: formatMessage({
        id: 'farms.deposit.processing',
      }),
      loading: txStatus === TX_STATUS.Pending && !error,
      approved: txStatus === TX_STATUS.Success,
      error: txStatus === TX_STATUS.Pending && error ? 'Failed' : undefined,
      errorMessage: formatMessage({
        id: 'farms.deposit.processingError',
      }),
    },
  ];

  return steps;
};

export const getWithdrawFarmFlow = (
  formatMessage: IntlFormatters['formatMessage'],
  txStatus: TxType,
  error: boolean,
  errorMessage: string,
): StepProps[] => {
  const steps = [
    {
      title: formatMessage({
        id: 'global.withdraw.confirm',
      }),
      loading: txStatus === TX_STATUS.Confirm && !error,
      approved: ![
        TX_STATUS.ApproveCoin0,
        TX_STATUS.ApproveCoin1,
        TX_STATUS.Confirm,
      ].includes(txStatus),
      error: txStatus === TX_STATUS.Confirm && error ? 'Rejected' : undefined,
      errorMessage:
        errorMessage ||
        formatMessage({
          id: 'farms.withdraw.confirmTxError',
        }),
    },
    {
      title: formatMessage({
        id: 'farms.withdraw.processing',
      }),
      loading: txStatus === TX_STATUS.Pending && !error,
      approved: txStatus === TX_STATUS.Success,
      error: txStatus === TX_STATUS.Pending && error ? 'Failed' : undefined,
      errorMessage: formatMessage({
        id: 'farms.withdraw.processingError',
      }),
    },
  ];

  return steps;
};

export const getClaimFlow = (
  formatMessage: IntlFormatters['formatMessage'],
  txStatus: TxType,
  error: boolean,
  errorMessage: string,
): StepProps[] => {
  const steps = [
    {
      title: formatMessage({
        id: 'farms.claim.confirm',
      }),
      loading: txStatus === TX_STATUS.Confirm && !error,
      approved: ![
        TX_STATUS.ApproveCoin0,
        TX_STATUS.ApproveCoin1,
        TX_STATUS.Confirm,
      ].includes(txStatus),
      error: txStatus === TX_STATUS.Confirm && error ? 'Rejected' : undefined,
      errorMessage:
        errorMessage ||
        formatMessage({
          id: 'farms.claim.confirmError',
        }),
    },
    {
      title: formatMessage({
        id: 'farms.claim.processing',
      }),
      loading: txStatus === TX_STATUS.Pending && !error,
      approved: txStatus === TX_STATUS.Success,
      error: txStatus === TX_STATUS.Pending && error ? 'Failed' : undefined,
      errorMessage: formatMessage({
        id: 'farms.claim.processingError',
      }),
    },
  ];

  return steps;
};
